var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":require("@/assets/profile.jpg")}}),_c('vue-particles',{attrs:{"color":"#dedede","particlesNumber":120}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }